import {registerHook} from 'structure-dispatcher'
import {invalidateApplicationCacheHook} from 'structure-cache-middleware'

registerHook({
  when: 'after',
  serviceName: 'applications',
  actionNames: ['updateById'],
}, invalidateApplicationCacheHook)
